export default {
  BASE_URL: "https://admin.goroketgo.com/api",//http://crmeb.funphoto.top/api http://www.sqf.com/api
  SERVER_URL: "https://admin.goroketgo.com"
}